import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
import { useNavigate } from "react-router-dom";
import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";
import targetaudience from "../../assets/Images/targetaudience.png";
import concept from "../../assets/Images/concept.png";
import product from "../../assets/Images/product.png";
import user from "../../assets/Images/user.png";






import "./LO.css"; // Import the CSS file

const LO1 = () => {
    const navigate = useNavigate();

    const cardslo1 = [
        {
            title: "Target Audience",
            description: "",
            image: targetaudience,
            path: '/lo1/targetaudience'
        },

        {
            title: "Concept",
            description: "",
            image: concept,
            path: '/lo1/concept'
        },

        // {
        //     title: "Design Proof of Concept",
        //     description: "",
        //     image: "",
        //     path: '/designproofofconcept'
        // },

        {
            title: "Interactive Product",
            description: "",
            image: product,
            path: '/lo1/interactiveproduct'
        },

        {
            title: "User Stories",
            description: "",
            image: user,
            path: '/lo1/userstories'
        },




        
        
    ];

    return (
        <div className="page-container">
            <Navbar />
            
            <div className="content-lo1-headings">
                <h1>Concept, Design, and Develop Interactive Media Product</h1>
                {/* <p></p> */}

                
            </div>

            <div className="line"></div>

            <div style={{ padding: '0.1rem 7.5rem' }}>
                <BreadcrumbHeader />
            </div>

            <div className="content-lo1">
                <div className="content-lo1-card-container">
                    {cardslo1.map(({ title, description, image, path }, index) => (
                        <div 
                            key={index} 
                            className="card-lo1" 
                            onClick={() => navigate(path)} // Navigate to respective page
                        >
                            <img src={image} alt={title} className="card-lo1-image" />
                            <h3 className="card-lo1-title">{title}</h3>
                            <p className="card-lo1-description">{description}</p>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default LO1;